import auth from './auth.js';
export default angular.module('eventix.common.services.oauthHeaders',[auth])
/**
 * @ngdoc service
 * @name eventix.common.services.OAuthHeaders
 * @requires eventix.common.services.Auth
 * @description
 * HTTP injector to add OAuth token headers into every request and globally respond to
 * `401 - Unauthorized`
 */
/**
 * @ngdoc service
 * @name eventix.common.services.OAuthHeadersProvider
 * @description
 * HTTP injector to add OAuth token headers into every request and globally respond to
 * `401 - Unauthorized`
 */
    .provider('OAuthHeaders', function() {
        var tokenType = 'credentials';
        /**
     * Implements $httpInterceptor methods for handling OAuth token in every request
     */
        return {
        /**
         * @ngdoc method
         * @name eventix.common.services.OAuthHeadersProvider#setStorageKey
         * @methodOf eventix.common.services.OAuthHeadersProvider
         * @description
         * Configure which token should be sent along with HTTP requests, only `client_credentials` and `password` are currenty supported
         *
         * @param {String} grantType Grant type
         */
            setGrantType: function(grantType) {
                tokenType = grantType;
            },
            $get: /*@ngInject*/ function($rootScope, $q, $window) {
                return {
                /**
                 * Add a oauth header if a token is available
                 *
                 * @param {Object} config HTTP request configuration object
                 * @returns {Object} HTTP request configuration object
                 */
                    request: function(config) {
                        let shouldAddAuthorization = false;

                        if (!_.isEmpty(config.url)) {
                            // Add authorization header if the path is relative to the base URL (which should always be a trusted domain/path)
                            shouldAddAuthorization = shouldAddAuthorization || (_.startsWith(config.url, '/') && !_.startsWith(config.url, '//'));
                            shouldAddAuthorization = shouldAddAuthorization || (!_.isEmpty(DASHBOARD_API_ROOT) && _.startsWith(config.url, DASHBOARD_API_ROOT));
                            shouldAddAuthorization = shouldAddAuthorization || (!_.isEmpty(SHOP_API_ROOT) && _.startsWith(config.url, SHOP_API_ROOT));
                            shouldAddAuthorization = shouldAddAuthorization || (!_.isEmpty(ORDER_API_ROOT) && _.startsWith(config.url, ORDER_API_ROOT));
                            shouldAddAuthorization = shouldAddAuthorization || (!_.isEmpty(AUTH_API_ROOT) && _.startsWith(config.url, AUTH_API_ROOT));
                        }

                        if (!shouldAddAuthorization || !$window.auth) {
                            return config;
                        }

                        const accessToken = $window.auth.getAccessToken();

                        if (!accessToken || !accessToken.access_token || !accessToken.access_token.length) {
                            return config;
                        }

                        config.headers.Authorization = 'Bearer ' + accessToken.access_token;

                        return config;

                    },
                    /**
                 * Respond to a 401 request, broadcasting the error
                 *
                 * @param {Object} response HTTP response object
                 * @returns {Object} HTTP response object
                 */
                    responseError: async function(response) {
                        if(response.status === 401) {
                            if(!response.config.headers.Authorization || !$window.auth.getAccessToken()){
                                $window.auth.logout();
                                return $q.reject(response);
                            }

                            if(response.config.headers.Authorization === 'Bearer ' + $window.auth.getAccessToken().access_token){
                                await $window.auth.refreshToken();
                            }

                            // Retry failed request
                            return $q.resolve($rootScope.http(response.config));
                        }

                        return $q.reject(response);
                    }
                };
            }
        };
    }).name;
